import { render, staticRenderFns } from "./CompleteAlert.vue?vue&type=template&id=145ca454"
import script from "./CompleteAlert.vue?vue&type=script&lang=ts"
export * from "./CompleteAlert.vue?vue&type=script&lang=ts"
import style0 from "./CompleteAlert.vue?vue&type=style&index=0&id=145ca454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports